<template>
  <div class="seriesLine" ref="seriesLine" :style="{height: '100%',width:this.width}"></div>
</template>

<script>
/* 下面渐变填充线 */

/* 
    使用位置
*/
import chartResize from '@/mixin/echart-resize.js'
export default {
  data() {
    return {
      areaColor: [['#21B3FA', '#202732'], ['#6AF29A', '#202732']],
      lineColor: ['#4992ff', '#6AF29A'],
      yAxisName: ["(单位/℃)", ""]
    }
  },
  mixins: [chartResize],
  props: {
    data: {
      type: Object,
      default: () => ({
        dataList: [
          {
            name: '冷冻供水温度',
            data: [
              [0, 30, 'unit'],
              [1, 11, 'unit'],
              [2, 23, 'unit'],
              [3, 55, 'unit'],
              [4, 24, 'unit'],
              [5, 66, 'unit'],
              [6, 22, 'unit'],
              [7, 26, 'unit'],
              [8, 34, 'unit'],
              [9, 33, 'unit'],
              [10, 64, 'unit'],
            ],
            areaColor: ['#21B3FA', '#202732'],
            lineColor: '#4992ff'

          },
          {
            name: '冷冻回水温度',
            data: [
              [0, 30],
              [1, 13],
              [2, 23],
              [3, 14],
              [4, 33],
              [5, 23],
              [6, 14],
              [7, 55],
              [8, 52],
              [9, 13],
              [10, 29],
            ],
            areaColor: ['#6AF29A', '#202732'],
            lineColor: '#01f6fb'
          },
        ],
        axisData: [
          '05-16 9:00:00',
          '05-16 10:00:00',
          '05-16 11:00:00',
          '05-16 12:00:00',
          '05-16 13:00:00',
          '05-16 14:00:00',
          '05-16 9:00:00',
          '05-16 10:00:00',
          '05-16 11:00:00',
          '05-16 12:00:00',
        ],
      })
    },

    symbolSize: {
      type: String,
      default: '0',
    },

    legendShow: {
      type: Boolean,
      default: true,
    },

    unit: {
      type: String,
      default: ''
    },
    color: {
      type: Array,
      default: () => ["rgb(83,253,254)", '"rgb(163,254,83)', "rgb(255,68,68)", "rgb(255,68,248)"],
    },

    smooth: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "auto"
    }

  },
  mounted() {
    this.draw()

  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) return this.draw()
      },
      deep: true
    }
  },
  computed: {
    hasNegative() {
      if (!this.data.dataList) return
      return this.data.dataList.some(item => {
        return item.data.some(ele => ele[1] < 0)
      })
    }
  },

  methods: {
    draw() {
      let yAxisName = this.data.yAxisName || ['(单位/℃)', '(单位/kW)']
      let d = this.data.dataList
      if (!d) return
      let axisData = this.data.axisData
      let series = d.map((t, i) => {
        let {
          name,
          mark,
          areaColor,
          areaStyle,
          itemStyle,
          dashed,
          data,
          lineColor,
          markLine,
        } = t



        if (t.mark) {
          markLine = {
            data: [{
              symbol: 'none',
              yAxis: mark
            }, {
              symbol: 'none',
              yAxis: mark
            }],
            label: { position: 'middle' }
          }
        }

        let symbol = +this.symbolSize ? 'emptyCircle' : 'none'

        let lineStyle


        lineStyle = {
          width: 1,
          color: lineColor || this.lineColor[i],
        }


        if (this.areaColor) {    // 如果有shadow需求
          areaStyle = {
            opacity: 1,

            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: areaColor ? areaColor[0] : this.areaColor[i][0]
              }, {
                offset: 1, color: areaColor ? areaColor[1] : this.areaColor[i][1]
              }],
            }
          }
          itemStyle = {
            color: areaColor ? areaColor[0] : this.areaColor[i][0],
            borderWidth: 2,
          }
        }


        return {
          name,
          data,
          markLine,
          lineStyle,
          areaStyle,
          itemStyle,
          yAxisIndex: i,
          smooth: this.smooth,
          type: 'line',
          symbol,
          symbolSize: this.symbolSize,    // 拐点大小

        }
      })

      this.myChart = this.$echarts.init(this.$refs.seriesLine)

      this.option = {
        backgroundColor: '#202732',
        color: this.color,
        tooltip: {
          trigger: 'axis',
          borderWidth: '0',
          backgroundColor: 'rgba(0,0,0,.8)',
          textStyle: { color: '#fff' },
          
          formatter(params) {
            let html = params[0].axisValue + '</br>'

            let htmlArr = params.map(t => {
              return t.marker + t.seriesName + ': ' + t.data[1] + ' ' + t.data[2] + '</br>'
            })

            html += htmlArr.join('')

            return html
          },
          hideDelay: 2000,
        },
        grid: {
          top: '7%',
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        legend: {
          show: this.legendShow,
          icon: "roundRect",
          textStyle: {
            color: '#fff'
          },
          top: "2%",
          right: "15%",
          data: d.map(t => t.name),
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: { // 坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: '#6a7079',
            },

          },
          axisLabel: { // 坐标轴刻度标签的相关设置
            textStyle: {
              color: '#E9F3FE',
            },
            // rotate: 45
          },
          axisTick: {
            show: false,
          },
          data: axisData,
        },
        yAxis: [{
          type: 'value',
          name: yAxisName[0],

          max: (value) => {
            if (Math.abs(value.max) > Math.abs(value.min)) {
              if (this.hasNegative) { return (Math.abs(value.max) * 1.2).toFixed(0); }
              return
            } else {
              if (this.hasNegative) { return (Math.abs(value.min) * 1.2).toFixed(0); }
              return
            }
          },
          min: (value) => {
            if (Math.abs(value.max) > Math.abs(value.min)) {
              if (this.hasNegative) { return (-Math.abs(value.max) * 1.2).toFixed(0); }
              return
            } else {
              if (this.hasNegative) {
                if (this.hasNegative) { return (-Math.abs(value.min) * 1.2).toFixed(0); }
                return
              }
            }
          },
          nameGap: 5,
          splitNumber: 4,
          nameTextStyle: {
            align: "center",
            lineHeight: 30,
            color: "#ffffff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#6a7079',
              width: 2
              // type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#6a7079',
            },

          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ffffff',
            },


          },
          axisTick: {
            show: false,
          },
        }, {
          type: 'value',
          name: yAxisName[1],
          max: (value) => {
            if (Math.abs(value.max) > Math.abs(value.min)) {
              if (this.hasNegative) { return (Math.abs(value.max) * 1.2).toFixed(0); }
              return
            } else {
              if (this.hasNegative) { return (Math.abs(value.min) * 1.2).toFixed(0); }
              return
            }
          },
          min: (value) => {
            if (Math.abs(value.max) > Math.abs(value.min)) {
              if (this.hasNegative) { return (-Math.abs(value.max) * 1.2).toFixed(0); }
              return
            } else {
              if (this.hasNegative) {
                if (this.hasNegative) { return (-Math.abs(value.min) * 1.2).toFixed(0); }
                return
              }
            }
          },
          nameTextStyle: {
            align: "center",
            lineHeight: 30,
            color: "#ffffff"
          },
          nameGap: 5,
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#6a7079',
              width: 2
              // type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#6a7079',
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ffffff',
            },
          },
          axisTick: {
            show: false,
          },
        },],
        dataZoom: {
          type: 'inside',
          start: 0,
        },
        series: series
      };

      this.myChart.setOption(this.option)
      this.observerStart("seriesLine")
    },

  },
}
</script>

<style lang="scss" scope>
.seriesLine {
  & > div:first-child {
    width: 100% !important;
    height: 100% !important;
  }
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
